import axios from './international';

export const getAgentOverdueList = (params) => axios.post('/agentOverdue/getAgentOverdueList', params);
export const isAgentOverdue = (agentName, integratorName) => axios.get('/agentOverdue/agent-is-overdue', { params: { agentName, integratorName } });
export const updateOverdueFlag = (params) => axios.post('/agentOverdue/updateOverdueFlag', params);
export const deleteAgentOverdue = (params) => axios.post('/agentOverdue/deleteAgentOverdue', params);
